import { render, staticRenderFns } from "./ReDashServiceStage.vue?vue&type=template&id=bef63904&scoped=true"
import script from "./ReDashServiceStage.vue?vue&type=script&lang=js"
export * from "./ReDashServiceStage.vue?vue&type=script&lang=js"
import style0 from "./ReDashServiceStage.vue?vue&type=style&index=0&id=bef63904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef63904",
  null
  
)

export default component.exports